import React from 'react';
import BorderOuterIcon from '@material-ui/icons/BorderOuter';
import createInlineStyleButton from '@studionand/ada-next/src/legacy/InlineToolbar/utils/createInlineStyleButton';
import createBlockTypeButton from '@studionand/ada-next/src/legacy/InlineToolbar/utils/createBlockTypeButton';
import LinkButton from '@studionand/ada-next/src/legacy/InlineToolbar/LinkButton';
// import Icon from '../commonV2/Icon';
import FormatMono from '@studionand/ada-next/src/icons/FormatMono';
import FormatBold from '@studionand/ada-next/src/icons/FormatBold';
import FormatItalic from '@studionand/ada-next/src/icons/FormatItalic';
import FormatUnderline from '@studionand/ada-next/src/icons/FormatUnderline';
import FormatQuote from '@studionand/ada-next/src/icons/FormatQuote';
import FormatListUnordered from '@studionand/ada-next/src/icons/FormatListUnordered';
import FormatListOrdered from '@studionand/ada-next/src/icons/FormatListOrdered';
import Headline1 from '@studionand/ada-next/src/icons/Headline1';
import Headline2 from '@studionand/ada-next/src/icons/Headline2';
import FormatSuper from '@studionand/ada-next/src/icons/FormatSuper';
import FormatSub from '@studionand/ada-next/src/icons/FormatSub';

const inlineServices = [ //eslint-disable-line
  createInlineStyleButton({
    inlineStyle: 'BOLD',
    children: <FormatBold fontSize="small" />,
  }),
  createInlineStyleButton({
    inlineStyle: 'ITALIC',
    children: <FormatItalic fontSize="small" />,
  }),
  createInlineStyleButton({
    inlineStyle: 'UNDERLINE',
    children: <FormatUnderline fontSize="small" />,
  }),
  createInlineStyleButton({
    inlineStyle: 'SUPER',
    children: <FormatSuper fontSize="small" />,
  }),
  createInlineStyleButton({
    inlineStyle: 'SUB',
    children: <FormatSub fontSize="small" />,
  }),
  createInlineStyleButton({
    inlineStyle: 'CODE',
    children: <FormatMono fontSize="small" />,
  }),
  createBlockTypeButton({
    blockType: 'header-one',
    children: <Headline1 fontSize="small" />,
  }),
  createBlockTypeButton({
    blockType: 'header-two',
    children: <Headline2 fontSize="small" />,
  }),
  createBlockTypeButton({
    blockType: 'blockquote',
    children: <FormatQuote fontSize="small" />,
  }),
  createBlockTypeButton({
    blockType: 'frame-block',
    children: <BorderOuterIcon fontSize="small" />,
  }),
  createBlockTypeButton({
    blockType: 'unordered-list-item',
    children: <FormatListUnordered fontSize="small" />,
  }),
  createBlockTypeButton({
    blockType: 'ordered-list-item',
    children: <FormatListOrdered fontSize="small" />,
  }),
  LinkButton,
];

export default inlineServices;
